const timeZoneCheck = (conf) => {
  let tz = 'Europe/Berlin'
  const config = conf
  let eventTz = ''
  if (config) {
    eventTz = config.config[0].EventTimeZone
  }
  if (eventTz) tz = eventTz
  return tz
}

export default timeZoneCheck
